/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-99
 */

"use strict"

import { qb } from "./index__part-98"
import * as /* [auto-meaningful-name] */Module_21 from /* 21 */"./21"
import { createElement, forwardRef } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_224 from /* 224 */"./224/index"
var Qb = function (e, t) {
  return createElement(Module_224.a, Module_21.a(Module_21.a({}, e), {}, {
    ref: t,
    icon: qb
  }))
}
Qb.displayName = "DownOutlined"
var Zb = forwardRef(Qb)
export { Zb }
